export enum OpsPlanningWorkOrderSummaryPdfRowStatus {
	Pending = 10,
	WorkInProgress = 20,
	Completed = 30,
}